/**
 * Draggable Instrument Item Component
 * Wraps an instrument item to make it draggable for drag-and-drop functionality
 */

import { useDrag, DragSourceMonitor } from 'react-dnd';
import { Instrument } from '@shared/types/instrument';

export interface DraggedInstrument {
  instrument_id: string;
  symbol: string;
  exchange?: string;
  name?: string;
}

interface DraggableInstrumentItemProps {
  instrument: Instrument;
  children: React.ReactNode;
}

export const INSTRUMENT_ITEM_TYPE = 'INSTRUMENT';

export function DraggableInstrumentItem({ instrument, children }: DraggableInstrumentItemProps) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: INSTRUMENT_ITEM_TYPE,
    item: {
      instrument_id: instrument.instrument_id,
      symbol: instrument.symbol,
      exchange: instrument.exchange,
      name: instrument.name,
    } as DraggedInstrument,
    collect: (monitor: DragSourceMonitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  return (
    <div
      ref={drag}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: 'grab',
      }}
    >
      {children}
    </div>
  );
}

